// Blueprint
import blueprint from '../view-findings/questions.json'

// ----------------------------------
// Encode drugs and question for url
// ----------------------------------
export function encode( faqs ) {

  const params = []

  if ( faqs && Object.keys( faqs ).length ) {
    // Iterate blueoprint
    var idIdx = 1
    for ( const id of Object.keys( blueprint ) ) {
      var keyIdx = 1
      const kvs = []
      for ( const key of Object.keys( blueprint[ id ] ) ) {
        if ( faqs[ id ] && faqs[ id ][ key ] && faqs[ id ][ key ] != "" ) {
          const valIdx = blueprint[ id ][ key ].indexOf( faqs[ id ][ key ] )
          kvs.push( `${keyIdx}${valIdx}` )
        }
        keyIdx++
      }
      // 17q 12 v 32  &  1q 12 v 13
      if ( kvs.length ) {
        params.push( `${idIdx}q${kvs.join("v")}` )
      }
      idIdx++
    }
  }

  return params

}


// --------------------------------
// Reconstruct faqs from blueprint
// @ return {}
// --------------------------------
export function decode( ikvs ) {
  // Nothing todo here
  if ( !ikvs.length ) return []

  // Transform questions from url to key value object
  const ikvs2 = ikvs.reduce( ( acc, cur ) => {
    const [ id, kvs ] = cur.split( "q" )
    if ( !kvs ) return acc
    for ( const kv of kvs.split( "v" ) ) {
      acc[ `${id}q${kv[0]}` ] = kv[ 1 ]
    }
    return acc
  }, {} )

  // Construct standard object
  const faqs = []
  // Iterate blueoprint
  var idIdx = 1
  for ( const id of Object.keys( blueprint ) ) {
    var keyIdx = 1
    for ( const key of Object.keys( blueprint[ id ] ) ) {
      if ( ikvs2[ `${idIdx}q${keyIdx}` ] ) {
        var valIdx = parseInt( ikvs2[ `${idIdx}q${keyIdx}` ] )
        faqs.push( { key: `${id}.${key}`, value: blueprint[ id ][ key ][ valIdx ] } )
      }
      keyIdx++
    }
    idIdx++
  }

  return faqs

}